import React from 'react';
import PropTypes from 'prop-types';
import Slide from './Slide';

const SliderInner = (props) => {
  const {
    items,
    slideStyle,
    activeSlideIndex,
    setCurrentMemberId,
    firstSlideIndex,
    offset,
  } = props;
  //
  const slides = [];
  items.forEach((item, index) => {
    slides.push(<Slide
      style={slideStyle}
      key={item[0].key}
      id={item[0].key}
      content={item}
      active={activeSlideIndex === index}
      onClick={setCurrentMemberId}
    />);
  }, this);
  //
  const style = {
    left: -(firstSlideIndex * slideStyle.width) + offset,
  };
  //
  return (
    <div className="slider-inner" style={style}>
      {slides}
    </div>
  );
};

SliderInner.propTypes = {
  activeSlideIndex: PropTypes.number,
  firstSlideIndex: PropTypes.number,
  items: PropTypes.instanceOf(Array).isRequired,
  slideStyle: PropTypes.instanceOf(Object).isRequired,
  offset: PropTypes.number.isRequired,
  setCurrentMemberId: PropTypes.func.isRequired,
};

SliderInner.defaultProps = {
  activeSlideIndex: null,
  firstSlideIndex: null,
};

export default SliderInner;
